<template>
    <div>
        <h1 :class="selected ? 'text-sm pt-2' : 'text-xl pt-0.5 font-bold'">
            Numéro de commande
        </h1>
        <sav-fold-card
        v-model="open"
        class="mt-4"
        :close-button="false"
        :id="$options.name"
        :can-open="canOpen"
        >
            <template v-slot:close>
                <div class="font-bold" v-if="selected">
                    <div>Numéro de commande: {{ selected.num }}</div>
                    <div>Produit: {{ selected.app.label }}</div>
                </div>
            </template>

            <template v-slot:open>
                <template v-if="!order">
                    <sav-input :label="$tt('Numéro de commande')" type="text" v-model="numCommande" :errors="errors" />
                    <button @click="searchCommande" class="mt-3 p-2 px-4 font-light duration-200 cursor-pointer bg-green-100 hover:bg-green-200 rounded text-sm">
                        <sav-spinner v-if="loadingSearch" :size="10" />
                        <template v-if="!loadingSearch">
                            <i class="fas fa-check mr-1"></i> Valider
                        </template>
                    </button>
                </template>
                <template v-if="order">
                    <div class="border-b pb-4 mb-4">
                        <div class="mb-1">Numéro de commande :</div>
                        <div class="flex items-center gap-4">
                            <div class="text-xl font-bold">{{ numCommande }}</div>
                            <button @click="resetForm" class="px-4 py-2 text-xs rounded bg-slate-100 hover:bg-slate-200 duration-200"><i class="fas fa-pen"></i></button>
                        </div>
                    </div>
                    <div class="mb-1">Séléctionner un produit :</div>
                    <div class="grid grid-cols-3 gap-4 items-center" v-for="(item, itemIndex) in order.order_lines" :key="'order-' + itemIndex" :class="itemIndex < order.order_lines.length - 1 ? 'mb-2 pb-2 border-b' : ''">
                        <div class="col-span-2">
                            <div class="font-bold">{{ item.label }}</div>
                            <div v-if="item.unit_price_including_vat" class="mt-0.5 font-light text-sm">{{ item.unit_price_including_vat.value }} €</div>
                        </div>
                        <div class="text-end">
                            <button @click="selectApp(item)" class="px-4 py-2 bg-slate-100 hover:bg-slate-200 duration-200 rounded text-sm">Sélectionner</button>
                        </div>
                    </div>
                </template>
            </template>
        </sav-fold-card>
    </div>
</template>

<script>
import axios from 'axios'
import FormCardExtension from '@/extends/FormCardExtension'
import apiService from '@/services/api.service'
import moment from 'moment'

export default {
    name: 'find-num-commande',
    extends: FormCardExtension,

    data() {
        return {
            numCommande: null,
            errors: [],
            loadingSearch: false,
            order: null,
        }
    },

    methods: {
        init() {
            this.loading = true

            // Check if data
            if (this.$formTool.getFormData(this.$options.name)) {
                this.selected = JSON.parse(JSON.stringify(this.$formTool.getFormData(this.$options.name)))
                this.numCommande = this.selected.num
                this.nextBlock = this.$formTool.blockData(this.$options.name).next
            }

            // Check can open card after set-case
            this.removeOpenAfterSetCase()

            this.loading = false
        },

        end(callbackData) {
            this.$formTool.addFormData(this.$options.name, callbackData)
            this.nextBlock = this.$formTool.blockData(this.$options.name).next
            if (this.selected) {
                this.$emit('update', this.$options.name)
            }
            this.selected = JSON.parse(JSON.stringify(callbackData))
        },

        async searchCommande() {
            this.errors = []
            this.loadingSearch = true
            let response = await axios.get('https://preprod.savlog.net/districloud/app/service/rest/ws.php?action=wynd&id_grossiste=82&token=8DROmU1h8uRUqDBdzLHkqJQqEzool125&operation=order_search&num_commande=' + this.numCommande)
            this.loadingSearch = false
            if (response.data.posts.post == 0) {
                this.$toast.error(this.$tt('Numéro de commande introuvable'))
                this.errors.push(this.$tt('Numéro de commande introuvable'))
                return
            } else {
                this.order = response.data.posts.post
            }
        },

        async selectApp(app) {
            let response = await apiService.post('getidbyean', {
                ean: app.reference
            })
            if (response.data.posts.post.length > 0) {
                let appDb = response.data.posts.post[0]
                this.$formTool.addFormData('device', [{value: {id: appDb.id, Modele: app.label}}])
                this.$formTool.addFormData('purchase-date', [{value: moment(this.order.created_at, 'DD/MM/YYYY').format('DD/MM/YYYY')}])

                // Save shop info
                let responseMag = await apiService.post('getmagbyid', {
                    id_mag: 20470
                })
                let magDb = responseMag.data.posts.post
                this.$formTool.addFormData('shop', [{value: magDb}])
                this.$formTool.addFormData('buy-online', 'online')
                this.$formTool.addFormData('num_cmd', this.numCommande)
                this.$formTool.addFormData('sign', {
                    ecommerce: 1,
                    hideLabel: false,
                    id: magDb.id_centrale_ha,
                    img: null,
                    label: magDb.centrale_ha
                })
                this.end({
                    num: this.numCommande,
                    app: app,
                    app_db: appDb
                })
            } else {
                this.$toast.error('Une erreur est survenue')
            }
            // console.log(app);
        },

        resetForm() {
            this.order = null
            this.numCommande = null
            this.$emit('reset-at', this.$options.name)
        }
    },

    mounted() {
        this.init()
    }
}
</script>



// WEBPACK FOOTER //
// src/processes/cards/product/FindNumCommande.vue